import Vue from 'vue';
import Router from 'vue-router';
import config from '../helpers/configProvider';
import { store } from '../store';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  base: config.getEnv(config.enum.VUE_APP_BASE_PATH) || '/',
  routes: [
    {
      path: '/',
      name: 'Map',
      component: () => import('@/components/Map'),
      props: { personId: undefined }
    },
    {
      path: '/list',
      name: 'List',
      component: () => import('@/components/PatientList')
    },
    {
      path: '/area-dashboard',
      name: 'AreaDashboard',
      component: () => import('@/components/AreaDashboard')
    },
    {
      path: '/chart',
      name: 'Chart',
      component: () => import('@/components/Chart')
    },
    {
      path: '/chartages',
      name: 'ChartAges',
      component: () => import('@/components/ChartAges')
    },
    {
      path: '/thematicMap',
      name: 'ThematicMap',
      component: () => import('@/components/ThematicMap')
    },
    {
      path: '/asuraMap',
      name: 'AsuraMap',
      component: () => import('@/components/AsuraMap')
    },
    {
      path: '/mobileTracking',
      name: 'MobileTrackingMap',
      component: () => import('@/components/MobileTrackingMap')
    },
    {
      path: '/extraLayers',
      name: 'ExtraLayers',
      component: () => import('@/components/ExtraLayers')
    },
    {
      path: '/import',
      name: 'Import',
      component: () => import('@/components/Import'),
      beforeEnter: (to, from, next) => {
        if (store.getters['account/isAdmin'] || store.getters['account/isEditor']) {
          return next();
        }
        return next('/');
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/components/Login')
    },
    {
      path: '/userlist',
      name: 'Users',
      component: () => import('@/components/Users'),
      beforeEnter: (to, from, next) => {
        if (store.getters['account/isAdmin']) {
          return next();
        }

        return next('/');
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = window.$cookies.get('user');

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  next();
});
